import script from "./originCommons.vue?vue&type=script&lang=js"
export * from "./originCommons.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__